import $ from 'jquery';
import './Language/TranslationStrings';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';

import './General/Lightbox';
import './General/Select';
// import './General/ChatBot';
import './General/LangMenu';
import './General/MetaMenu';
import './General/NavToggle';
import './General/Visionbar';
//import './General/BackToTop';
import './General/Datepicker';
import './General/SmoothScroll';
import './General/IconSwitch';
import './General/ImageInfo';
import './General/QuickBooking';
import './General/JumpNav';
import './General/Toolbar';
import './General/BookingBar';

// should be fairly late, or use window.observeTrackBanners for additional tracking
import './General/Banners';

import './Menus/Mobile';
import './Menus/Desktop';

import './Mask/Slider';
// import './Mask/Gallery';
// import './Mask/Youtube';
// import './Mask/Maps';
import './Mask/Accordion';
import './Mask/BannerSlider';
import './Mask/SpreewaldAktuell';
import './Mask/Impressions';
import './Mask/MomentsTeaser';
import './Mask/FilterEvents';
import './Mask/Tiles/index';

import './Extensions/Wishlist';
import './Extensions/TourismOffers/Main';
import './Extensions/Banner/Form';
import './Extensions/IbeFixes';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}

(function () {
    Parsley.on('form:validate', function () {
        this.$element.find('.help-block.error').remove();
    });
})();
